export default "__VITE_ASSET__BYPt03EK__"